import React, { useContext, useState } from 'react';

import { Link, useHistory } from 'react-router-dom';

import { Spinner } from '../../../StyledComponent';

import { ContextSolicitacoes } from '../../../../services/solicitacoes';

import { ContextSindico } from '../../../../services/sindico';

import { ContextoListaApartamentos } from '../../../ApartamentList/contextoImoveis';

import { CriarSolicitacaoBtn } from './styles';
import loadSindico from '../../../../Pages/Sindico/loadSindico';
import MessagePopUp from '../../../MessagePopup';
import { ButtonPrimary } from '../../../StyledComponent';

const CriarSolicitacao = ({
  listaDeImoveis,
  imovelSelecionado,
  listaTipoSolicitacoes,
  tipoSelecionado,
  assunto,
  descricao,
  setCasosDeReparoScreen,
  casosDeReparoScreen,
  setErrorMsg,
  horarioSelecionado,
  setErrorMsgAgendamento,
  agentes,
  reparos,
  documents,
  setErroHorarioNaoDisponivel,
  tipoAtendimentoSolicitacao,
  tiposSolicitacaoComAgendamento,
  entendiConcordo,
  isSindico,
  disabled,
  contato,
  handleGoBack,
}) => {
  const history = useHistory();

  const [
    showSucessCreateSolicitacaoPopup,
    setShowSucessCreateSolicitacaoPopup,
  ] = useState(false);

  const [showErrorCreateSolicitacaoPopup, setShowErrorCreateSolicitacaoPopup] =
    useState(false);

  const {
    getVerificaAgendamento,
    reloadPeriodoAgente,
    criarAgendamento,
    criarSolicitacao,
    saveFiles,
    aceiteTermoAgendamento,
  } = useContext(isSindico ? ContextSindico : ContextSolicitacoes);

  const { tema } = useContext(
    isSindico ? ContextSindico : ContextoListaApartamentos
  );

  const [loadingTentativaAgendamento, setLoadingTentativaAgendamento] =
    useState(false);

  const [errorMsgAgendamentoTimeOut, setErrorMsgAgendamentoTimeOut] =
    useState(false);

  const result = listaDeImoveis.filter(imovelSelecionado);

  const resultType = listaTipoSolicitacoes.filter(tipoSelecionado);

  const [redirectSolicitationId, setRedirectSolicitationId] =
    useState(undefined);

  async function cadastraNovaSolicitacao() {
    setLoadingTentativaAgendamento(true);

    const resultCriarSolicitacao = await criarSolicitacao({
      subgrupo: resultType[0].tipoSolicitacaoIdSalesForce,
      subject: assunto,
      description: descricao,
      assetId: result[0].assetId,
    });

    if (!resultCriarSolicitacao) {
      setErrorMsg(true);
      setLoadingTentativaAgendamento(false);
      // setLoading(false);
      setErrorMsgAgendamentoTimeOut(true);
    } else {
      setRedirectSolicitationId(resultCriarSolicitacao?.id);
      await saveFiles(documents, resultCriarSolicitacao?.id);
      setShowSucessCreateSolicitacaoPopup(true);
    }
  }

  async function cadastraNovaSolicitacaoSindico() {
    setLoadingTentativaAgendamento(true);

    const resultCriarSolicitacao = await criarSolicitacao({
      subgrupo: resultType[0].tipoSolicitacaoIdSalesForce,
      subject: assunto,
      description: descricao,
      assetId: result[0].assetId,
      observacoes: contato,
    });

    if (!resultCriarSolicitacao) {
      setErrorMsg(true);
      setLoadingTentativaAgendamento(false);
      // setLoading(false);
      setErrorMsgAgendamentoTimeOut(true);
    } else {
      setRedirectSolicitationId(resultCriarSolicitacao?.id);
      await saveFiles(documents, resultCriarSolicitacao?.id);
      setShowSucessCreateSolicitacaoPopup(true);
    }
  }

  function filtraDataPeloHorario() {
    let resultFiltro = agentes[0]?.intervals.filter((turno) => {
      return turno.label == horarioSelecionado.split(' - ')[1];
    });
    return resultFiltro;
  }

  function filtraDataPeloTurno() {
    let resultFiltro = agentes[0].intervals.filter((turno) => {
      return turno.interval.turno == horarioSelecionado;
    });
    return resultFiltro;
  }

  // para agendamento COM assistência técnica que tem apontamentos e motivos
  async function agendar() {
    try {
      setLoadingTentativaAgendamento(true);

      await getVerificaAgendamento(
        resultType[0].tipoSolicitacaoIdSalesForce,
        isSindico ? result[0].assetId : result[0].id
      );

      let horaDoDiaSelecionado =
        tipoAtendimentoSolicitacao === 'Assistência Técnica'
          ? filtraDataPeloTurno()
          : filtraDataPeloHorario();

      const timeZoneOffSet = new Date().getTimezoneOffset();

      // para a hora
      const startDate = new Date(agentes[0].date_x);
      const startHour = new Date(horaDoDiaSelecionado[0].interval.start);

      startDate.setMinutes(timeZoneOffSet);

      startDate.setHours(startHour.getHours());
      startDate.setMinutes(startHour.getMinutes());

      const finishDate = new Date(agentes[0].date_x);
      const finisHour = new Date(horaDoDiaSelecionado[0].interval.finish);

      finishDate.setMinutes(timeZoneOffSet);

      finishDate.setHours(finisHour.getHours());
      finishDate.setMinutes(finisHour.getMinutes());

      let arrayIdApontamentos = [];

      reparos?.forEach((reparo) => {
        arrayIdApontamentos.push({
          workTypeId: reparo.workTypeId,
          description: reparo.description,
        });
      });

      let agendamentoUnico = {
        // dados de -caso- vem da tela anterior e estão armazenados no objeto novaSolicitacao
        caso: {
          subgrupo: resultType[0]?.tipoSolicitacaoIdSalesForce,
          subject: assunto,
          description: descricao,
          assetId: result[0]?.assetId,
          id: result[0]?.id,
          contactId: isSindico && loadSindico()?.contactId,
          observacoes: contato,
        },
        imovel: {
          Bloqueio: isSindico
            ? result[0]?.bloqueio?.toString()
            : listaDeImoveis[0]?.imovel?.Bloqueio?.toString(),
          CodigosUAU: isSindico
            ? result[0].codigosUau
            : listaDeImoveis[0]?.imovel?.CodigosUAU,
          CodigoObra: isSindico
            ? result[0].codigoObra
            : listaDeImoveis[0]?.imovel?.CodigoObra,
        },
        ordemServico: {
          serviceTerritoryId: isSindico
            ? result[0].serviceTerritoryId
            : listaDeImoveis[0].imovel.serviceTerritoryId,
          subject: assunto,
          description: descricao,
        },
        itemsOrdemServico: arrayIdApontamentos ?? null,
        agendamento: {
          schedEndTime: finishDate,
          schedStartTime: startDate,
          serviceTerritoryId: isSindico
            ? result[0].serviceTerritoryId
            : listaDeImoveis[0]?.imovel.serviceTerritoryId == null
            ? null
            : listaDeImoveis[0]?.imovel?.serviceTerritoryId.toString(),
          earliestStartTime: startDate ?? '1969-01-01T00:00:00',
        },
        recurso: {
          serviceResourceId:
            agentes[0]?.intervals[0]?.resources[0]?.serviceResourceId.toString(),
        },
        empreendimentoIdSalesforce: isSindico && result[0]?.id,
      };

      let resultPostAssitenciaTecnica = await criarAgendamento(
        agendamentoUnico
      );

      if (resultPostAssitenciaTecnica?.caseNumber != undefined) {
        aceiteTermoAgendamento(
          resultPostAssitenciaTecnica.caseNumber,
          resultPostAssitenciaTecnica.id,
          resultPostAssitenciaTecnica.subgrupo
        );

        if (reparos?.length === 0) {
          // caso seja outro tipo que precise de agendamento
          // exemplo: vistoria, entrega de unidade
          await saveFiles(documents, resultPostAssitenciaTecnica?.id);
        } else {
          // caso seja assistencia tecnica
          await saveFiles(reparos, resultPostAssitenciaTecnica?.id);
        }

        setRedirectSolicitationId(resultPostAssitenciaTecnica.id);
        setShowSucessCreateSolicitacaoPopup(true);
        return;
      }

      if (
        resultPostAssitenciaTecnica?.response?.includes(
          'Ja Existe Um Compromisso de Serviço'
        ) ||
        resultPostAssitenciaTecnica?.response?.includes('UNABLE_TO_LOCK_ROW')
      ) {
        await reloadPeriodoAgente();
        setErroHorarioNaoDisponivel(true);
        return;
      }

      if (resultPostAssitenciaTecnica?.status > 500) {
        setErrorMsgAgendamentoTimeOut(true);
        return;
      }

      setShowErrorCreateSolicitacaoPopup(true);
    } catch (error) {
      setErrorMsgAgendamento(error?.response?.data);
    } finally {
      setLoadingTentativaAgendamento(false);
    }
  }

  const handleCadastrarSolicitacao = async () => {
    if (tiposSolicitacaoComAgendamento.includes(tipoAtendimentoSolicitacao)) {
      await agendar();
    } else {
      isSindico
        ? await cadastraNovaSolicitacaoSindico()
        : await cadastraNovaSolicitacao();
    }
  };

  if (errorMsgAgendamentoTimeOut) {
    return (
      <p
        className='novaSolicitacao__errorMsg centralized-column'
        style={{ width: '100%', cursor: 'auto' }}
      >
        Sua solicitação está sendo processada em nosso sistema.
        <span style={{ display: 'block' }}>
          Por gentileza,{' '}
          <Link
            to={isSindico ? '/sindico/solicitacoes-abertas/' : '/solicitacoes'}
          >
            clique aqui
          </Link>{' '}
          para acompanhar sua solicitação.
        </span>
        <br />
        <span>
          Caso não tenha sido criada entre em contato pelo número 4002-2600 ou
          pelo
        </span>{' '}
        <Link to={'/precisa-de-ajuda'} style={{ pointerEvents: 'all' }}>
          formulário de ajuda!
        </Link>
      </p>
    );
  }

  async function redirectToSolicitations(id) {
    setLoadingTentativaAgendamento(false);
    setCasosDeReparoScreen(true);

    history.push({
      pathname: `/solicitacoes/acompanhar-solicitacao/${id}`,
    });
  }

  async function redirectToSolicitationsSindico(id) {
    setLoadingTentativaAgendamento(false);
    setCasosDeReparoScreen(true);

    history.push({
      pathname: `/sindico/acompanhar-solicitacao/${id}`,
    });
  }

  const isDisabledIfCasoDeReparoScreen = () => {
    if (casosDeReparoScreen) {
      return !reparos.length > 0 || !entendiConcordo;
    }

    return false;
  };

  async function handleClickConfirmarPopup() {
    if (isSindico) {
      await redirectToSolicitationsSindico(redirectSolicitationId);
    } else {
      await redirectToSolicitations(redirectSolicitationId);
    }

    setShowSucessCreateSolicitacaoPopup(false);
    setRedirectSolicitationId(undefined);
  }

  return (
    <>
      {/* <p>
        Clique em confirmar para concluir sua solicitação, ou clique em voltar
        caso deseje editá-la.
      </p> */}
      <div className='centralized-space-between' style={{ marginTop: '16px' }}>
        <CriarSolicitacaoBtn
          disabled={false || loadingTentativaAgendamento}
          color={tema.primaryColor}
          border
          onClick={handleGoBack}
          id={'btnVoltar'}
        >
          VOLTAR
        </CriarSolicitacaoBtn>

        <CriarSolicitacaoBtn
          bg={tema.primaryColor}
          onClick={handleCadastrarSolicitacao}
          disabled={
            (!casosDeReparoScreen && disabled) ||
            (casosDeReparoScreen && isDisabledIfCasoDeReparoScreen()) ||
            loadingTentativaAgendamento
          }
        >
          FINALIZAR SUA SOLICITAÇÃO
          {loadingTentativaAgendamento && <Spinner />}
        </CriarSolicitacaoBtn>
      </div>

      {showSucessCreateSolicitacaoPopup && (
        <MessagePopUp
          title={'Solicitação realizada!'}
          message={'A sua solicitação foi realizada com sucesso'}
        >
          <ButtonPrimary
            fullWidth
            tema={tema}
            onClick={() =>
              (async function () {
                await handleClickConfirmarPopup();
              })()
            }
            id={'btnConfirmarSolicitacao'}
          >
            Confirmar
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {showErrorCreateSolicitacaoPopup && (
        <MessagePopUp
          isError
          title={'Erro!'}
          message={
            <>
              <span>
                Não foi possível criar a sua solicitação. Por favor tente
                novamente!
              </span>
              <br />
              <span>
                Caso o problema permaneça entre em contato pelo número 4002-2600
                ou pelo
              </span>{' '}
              <Link to={'/precisa-de-ajuda'} style={{ pointerEvents: 'all' }}>
                formulário de ajuda!
              </Link>
            </>
          }
        >
          <ButtonPrimary
            fullWidth
            tema={tema}
            onClick={() => setShowErrorCreateSolicitacaoPopup(false)}
            id={'btnFecharErroCriacaoSolicitacao'}
          >
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </>
  );
};

export default CriarSolicitacao;
